/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MySvgControllerService } from './services/my-svg-controller.service';
import { OperationFigureControllerService } from './services/operation-figure-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MySvgControllerService,
    OperationFigureControllerService,
    ApiConfiguration
  ],
})
export class OperationFiguresModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<OperationFiguresModule> {
    return {
      ngModule: OperationFiguresModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: OperationFiguresModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('OperationFiguresModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
